import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from './partial/shared.module';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { HeaderComponent } from './layout/admin-layout/header/header.component';
import { BlankLayoutComponent } from './layout/blank-layout/blank-layout.component';
import { NotAuthComponent } from './pages/not-auth/not-auth.component';
import { ErrorComponent } from './pages/error/error.component';
import { TitleStrategy } from '@angular/router';
import { SiteNamePageTitleStrategy } from './helpers/site-name-page-title-strategy';
import { environment } from 'src/environments/environment';
import { initializeApp } from 'firebase/app';
import { MyInboxModule } from './features/my-inbox/my-inbox.module';
import { WorkFlowSettingComponent } from './features/work-flow-setting/work-flow-setting.component';
import { CustomDateReportPipe } from './helpers/custom-date-report.pipe';
initializeApp(environment.firebase);

// AOT compilation support
function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    HeaderComponent,
    BlankLayoutComponent,
    ErrorComponent,
    NotAuthComponent,
    WorkFlowSettingComponent,
   
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
  ],
  exports: [
    TranslateModule,
  ],
  providers: [
    { provide: TitleStrategy, useClass: SiteNamePageTitleStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 
      localStorage.getItem('language') || localStorage.setItem('language', 'en')
     },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
